export const CLEAR_LOGISTIC_AREAS = '@@toyota/CLEAR_LOGISTIC_AREAS';
export const FETCHING_LOGISTIC_AREAS = '@@toyota/FETCHING_LOGISTIC_AREAS';
export const FETCHED_LOGISTIC_AREAS = '@@toyota/FETCHED_LOGISTIC_AREAS';
export const FETCHED_LOGISTIC_AREAS_FAILED = '@@toyota/FETCHED_LOGISTIC_AREAS_FAILED';
export const ADDING_LOGISTIC_AREAS = '@@toyota/ADDING_LOGISTIC_AREAS';
export const ADDED_LOGISTIC_AREAS = '@@toyota/ADDED_LOGISTIC_AREAS';
export const ADDED_LOGISTIC_AREAS_FAILED = '@@toyota/ADDED_LOGISTIC_AREAS_FAILED';
export const UPDATING_LOGISTIC_AREAS = '@@toyota/UPDATING_LOGISTIC_AREAS';
export const UPDATED_LOGISTIC_AREAS = '@@toyota/UPDATED_LOGISTIC_AREAS';
export const UPDATED_LOGISTIC_AREAS_FAILED = '@@toyota/UPDATED_LOGISTIC_AREAS_FAILED';
